import React from "react";

/**
 * Full-bleed ticker of live client domains. Gives the page constant ambient motion
 * between the hero and the work section, and reads as a credential strip rather
 * than decoration: every item is a real site you can open.
 *
 * The track holds the list twice and translates -50%, so the loop is seamless.
 */
export function DomainMarquee({ sites }) {
  const run = [...sites, ...sites];

  return (
    <div
      className="dp-marquee relative overflow-hidden border-y border-[#121E33] bg-[#080F1C]/60 py-5"
      aria-label="Live client websites"
    >
      {/* Fade the edges so items enter and leave rather than getting cut */}
      <div
        className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#060B14] to-transparent"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#060B14] to-transparent"
        aria-hidden="true"
      />

      <div className="dp-marquee-track flex w-max items-center">
        {run.map((site, i) => (
          <a
            key={`${site.domain}-${i}`}
            href={site.url}
            target="_blank"
            rel="noopener noreferrer"
            // The duplicate half is decorative; keep it out of the accessibility tree.
            aria-hidden={i >= sites.length ? "true" : undefined}
            tabIndex={i >= sites.length ? -1 : undefined}
            className="dp-focus group flex shrink-0 items-center gap-3 px-6 sm:px-8"
          >
            <span className="h-1 w-1 shrink-0 rounded-full bg-[#FF6A3D]" aria-hidden="true" />
            <span className="dp-mono whitespace-nowrap text-[13px] text-[#8FA3C0] transition-colors duration-300 group-hover:text-white">
              {site.domain}
            </span>
            <span className="dp-mono whitespace-nowrap text-[10px] uppercase tracking-[0.16em] text-[#33486B]">
              {site.sector}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default DomainMarquee;
